import { render, staticRenderFns } from "./ProductEditPanel.vue?vue&type=template&id=21c46aa6&scoped=true&"
import script from "./ProductEditPanel.vue?vue&type=script&lang=js&"
export * from "./ProductEditPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c46aa6",
  null
  
)

export default component.exports